import { FC } from 'react';
import { Checkbox, Form } from 'antd';
import { Trans } from 'react-i18next';

import { FormItem, SubmitButton, TextField } from 'componets/form';
import { CreateAccountPassword } from './CreateAccountPassword';

import { FieldData } from 'models';
import { useAppSelector, useTranslate } from 'hooks';
import { Rules, RequestStatus } from 'utils/constants';

import styles from './index.module.scss';

type CreateAccountFormProps = {
	onFinish: (values: any) => void;
	fields: FieldData[];
	onFieldsChange: ((changedFields: FieldData[], allFields: FieldData[]) => void) | undefined;
	initialValues: { [key: string]: string | null };
};

export const CreateAccountForm: FC<CreateAccountFormProps> = ({
	onFinish,
	fields,
	onFieldsChange,
	initialValues,
}) => {
	const loading = useAppSelector((state) => state.registration.status);

	const { emailText, passwordText, createAccountText } = useTranslate([
		'emailText',
		'passwordText',
		'createAccountText',
	]);

	return (
		<Form
			onFinish={onFinish}
			onFieldsChange={onFieldsChange}
			fields={fields}
			initialValues={initialValues}
		>
			<FormItem
				validateTrigger="onSubmit"
				rules={[Rules.REQUIRED, Rules.EMAIL]}
				name="email"
				className="email"
			>
				<TextField label={emailText} />
			</FormItem>

			<FormItem
				className={`${styles.password} password`}
				rules={[Rules.REQUIRED, Rules.PASSWORD]}
				name="password"
				validateTrigger="onSubmit"
			>
				<TextField label={passwordText} type="password" />
			</FormItem>
			<FormItem name="password" className="passwordIncludes">
				<CreateAccountPassword />
			</FormItem>
			<FormItem
				className="checkbox"
				name="agreeWithPolicyAndTerms"
				valuePropName="checked"
				rules={[Rules.REQUIRED_CHECKBOX]}
			>
				<Checkbox>
					<Trans
						i18nKey="confirmPrivacyText"
						components={{
							privacy_link_lt: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/06/Privatumo_politika.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
							privacy_link_en: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/06/Privacy_policy.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
							privacy_link_ro: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/06/Privacy_policy.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
							privacy_link_pt: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/06/Privacy_policy.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
							term_use_lt: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/01/Sutelktinio_finansavimo_platformos_%D0%A1rowdpear_naudojimosi_sutartis.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
							term_use_en: (
								<a
									href="https://crowdpear.com/wp-content/uploads/2026/01/Usage_Agreement_Of_The_Crowdfunding_Platform_Crowdpear.pdf"
									target="_blank"
									rel="noreferrer"
								/>
							),
						}}
					/>
				</Checkbox>
			</FormItem>

			<SubmitButton text={createAccountText} loading={loading === RequestStatus.PENDING} />
		</Form>
	);
};
